import { Component, Input, OnInit } from '@angular/core';
import { UtilService } from '@helpers/util.service';
import * as models from '@modules/real-property-agent-details/modules/agent-score/models';
import { Observable } from 'rxjs';

import * as services from './services';

@Component({
  selector: 'app-agent-score',
  templateUrl: './agent-score.component.html',
  styleUrls: ['./agent-score.component.scss'],
})
export class AgentScoreComponent implements OnInit {
  @Input()
  private readonly agentId: number;

  @Input()
  public readonly rating: number;

  @Input()
  public readonly averageClientRating: number;

  agentScore$: Observable<models.AgentScore[]>;
  agentClientScore$: Observable<models.AgentScore[]>;

  constructor(
    private agentScoreService: services.AgentScoreService,
    private utilService: UtilService,
  ) {}

  ngOnInit(): void {
    if (this.agentId) {
      this.agentScore$ = this.agentScoreService.getAgentScore(this.agentId);
      this.agentClientScore$ = this.agentScoreService.getAgentClientScore(this.agentId);
    }
  }

  public getImageUrl(url: string): string {
    const path = this.utilService.getFilePath();
    return path + url;
  }
}
